import { InvestmentStatus } from '../../enum/investment-status.enum';
import { PaymentTo } from '../../enum/payment-to-type.enum';
import { PaymentType } from '../../enum/payment-type.enum';
import { RefundStatus } from '../../enum/refund-status.enum';
import { Attachment } from '../attachment/attachment';
import { InvestedCampaign } from '../campaign/invested-campaign';
import { CompanyInfo } from '../company/company-info';
import { UserProfile } from '../user/user-profile';

export class InvestmentModel {
  company: CompanyInfo;
  campaign: InvestedCampaign;
  id: number;
  campaignId: number;
  userId: string;
  isAnonymous: boolean;
  pledgedAmount: number;
  currentAmount: number;
  // FRC-991: the amount the investor actually paid, as opposed to `pledgedAmount`
  // (the pre-payment pledge). The API has always returned both on
  // GetInvestmentResponse — only the model never declared them.
  // Domain comment: "Amount banked in/paid. Should be equal to PledgedAmount if paid."
  bankInAmount: number;
  // "Amount that should be refunded" — populated when a refund is REQUESTED, not
  // when it is paid out, so it must always be read together with `refundStatus`.
  refundedAmount: number;
  refundStatus: RefundStatus;
  investmentStatus: InvestmentStatus;
  paymentType: PaymentType;
  paymentGatewayReferenceNumber: string;
  lotQuantity: number;
  shareQuantity: number;
  createdAt: string;
  referenceNumber: string;
  investedOn: number;
  bankInAt: string;
  shareType: number;
  investmentEddId: number;
  investmentEddFormId: number;
  user: UserProfile;
  digitalCert?: Attachment;
  lifecycleBucket?: string | number;
  referralCode?: string;
  hasReferralCode: boolean;
  isNominee: boolean;
  paymentTo: PaymentTo;
  bonusShareShareQuantity: number;
  finalBonusShareShareQuantity: number;
  reviewStatus: number;
}
